import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { AccordionModule } from "primeng/accordion";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ChartModule } from "primeng/chart";
import { OrderListModule } from "primeng/orderlist";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { DashboardMainComponent } from "./components/dashboard-main/dashboard-main.component";
import { DashboardMainService } from "./dashboard-main.service";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@NgModule({
	declarations: [DashboardMainComponent, DashboardMainComponent],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		AccordionModule,
		ScrollPanelModule,
		ChartModule,
		OrderListModule,
		TableModule,
		DropdownModule,
		SchoolselectorModule,
		ProgressSpinnerModule,
	],
	providers: [DashboardMainService],
})
export class DashboardMainModule {}
